<template>
  <div class="salary">
    <div style="overflow:hidden">
      <div class="blue"></div>
      <p class="title">就业通报</p>
      <router-link to="/jiuye_sh.html">
        <p class="more">更多></p>
      </router-link>
    </div>
    <div class="ssgx-item" align="center">
      <div>
        <div class="header">
          <p>姓名</p>
          <p>学历</p>
          <p>专业</p>
          <p>就业企业</p>
          <p>城市</p>
        </div>
        <div class="salary-wrap">
          <swiper
            class="salary-list swiper swiper-container"
            :options="swiperOptions"
            ref="mySwiper"
            v-if="list.length > 1"
          >
            <swiper-slide
              class="li"
              v-for="(item, index) in list"
              :index="index"
              :key="index"
            >
              <p>{{ item.name }}</p>
              <p>{{ item.degree }}</p>
              <p>{{ item.major }}</p>
              <p>{{ item.company }}</p>
              <p>{{ item.city }}</p>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
// import 'swiper/css/swiper.css'
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      id: "",
      swiperOptions: {
        initialSlide: 0,
        direction: "vertical",
        loop: true,
        mousewheel: true,
        slidesPerView: "auto",
        // slidesPerView: 8,
        // loopedSlides: 3,
        // spaceBetween: 0,
        // autoplay: true,
        observer: true,
        observeParents: true,
        autoHeight: true,
        autoplay: {
          delay: 2000
          // stopOnLastSlide: false,
          // disableOnInteraction: false,
        }
      },
      list: []
    };
  },
  //   computed: {
  //         swiper() {
  //             return this.$refs.mySwiper.swiper
  //         }
  //   },
  mounted() {
    this.getData();
    // this.initSwiper()
  },
  methods: {
    getData() {
      this.axios
        // .get("/api/consume/ObtainSalary")
        .get("/api/consume/ObtainInfo/HomeData")
        .then(res => {
          this.list = res.data;
          // this.$nextTick(() => {
          //     this.initSwiper()
          // })
        });
    }
    //   touchstart() {
    //       mySwiper.autoplay.stop()
    //   },
    //   touchend() {
    //       mySwiper.autoplay.start()
    //   },
    // initSwiper() {
    //         var mySwiper = new Swiper('.swiper-container', {
    //         direction: 'vertical',
    //         loop: true,
    //         autoplay: {
    //             delay: 2000,
    //         },
    //         slidesPerView : 'auto',
    //         slidesPerView: 11,
    //         observer:true,
    //         observeParents:true,
    //     })
    // }
  }
};
</script>

<style>
.salary {
  padding-top: 52px;
  box-sizing: border-box;
}
.salary .img {
  text-align: center;
  margin-top: 42px;
  margin-bottom: 52px;
}
.salary .img img {
  width: 689px;
  height: 240px;
  border-radius: 10px;
}
.salary .blue {
  width: 6px;
  height: 30px;
  background: #64b3f1;
  float: left;
  margin-top: 5px;
  margin-left: 30px;
}
.title {
  font-size: 32px;
  color: #282828;
  font-weight: bold;
  float: left;
  margin-left: 22px;
}
.salary .more {
  float: right;
  font-size: 22px;
  margin-right: 35.5px;
  line-height: 44px;
  color: #666;
}
.ssgx-item {
  width: 90%;
  margin: 40px auto 30px;
}
.salary .header {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #6f9eff;
  color: #fff;
  display: flex;
  flex-direction: row;
}
.salary .header > p {
  border: 1px solid #ccc;
  text-align: center;
  border-left: none;
}
.salary .header > p:nth-child(1) {
  width: 15%;
}
.salary .header > p:nth-child(2) {
  width: 15%;
}
.salary .header > p:nth-child(3) {
  width: 20%;
}
.salary .header > p:nth-child(4) {
  width: 35%;
}
.salary .header > p:nth-child(5) {
  width: 20%;
  border-right: none;
}
.salary-wrap {
  /* height: 507px; */
  height: 460px;
  overflow: hidden;
  position: relative;
}
.salary-wrap .swiper-container {
  height: 100%;
}
.swiper-wrapper {
  position: absolute;
  height: 100%;
}
.salary-list {
  pointer-events: none;
  color: #565656;
  /* height: 507px;
    overflow: hidden;
    position: relative; */
}
.salary-list .li {
  display: flex;
  flex-direction: row;
  height: 46px !important;
}

.salary-list .li > p {
  text-align: center;
  height: 46px;
  line-height: 46px;
  border: 1px solid #e2e2e2;
  /* border-top: none; */
}
.salary-list .li > p:nth-child(1) {
  width: 15%;
  border-right: none;
  border-bottom: none;
}
.salary-list .li > p:nth-child(2) {
  width: 15%;
  border-right: none;
}
.salary-list .li > p:nth-child(3) {
  width: 20%;
  padding-left: 10px;
  padding-right: 10px;
  /* white-space: nowrap; */
  overflow: hidden;
  /* text-overflow: ellipsis; */
  border-right: none;
  border-bottom: none;
}
.salary-list .li > p:nth-child(4) {
  width: 35%;
  padding-left: 10px;
  padding-right: 10px;
  /* white-space: nowrap; */
  overflow: hidden;
  /* text-overflow: ellipsis; */
  border-right: none;
}
.salary-list .li > p:nth-child(5) {
  width: 20%;
  border-bottom: none;
}
.salary-list .li:last-child(1) > p:nth-child(2n + 1) {
  border-bottom: none;
}
.salary-list .li > p:nth-child(2n) {
  background-color: #f7f7f7;
}
</style>



// WEBPACK FOOTER //
// src/components/Salarylist.vue